module.exports = __webpack_public_path__ + "img/shuwen1.84e66048.jpg";